<template>
  <div>
    <div class="vx-row">
      <!-- MULTIPLE COLUMNS-->
      <div class="vx-col w-full mb-base">
        <vx-card title="">
          <div class="vx-row">

            <div class="vx-col sm:w-1/4 w-full mb-1">          
              <datepicker placeholder="Baslangıç Tarihi" :format="format" v-model="baslangic"></datepicker>
            </div>
            <div class="vx-col sm:w-1/4 w-full mb-1">
              <datepicker placeholder="Bitiş Tarihi" :format="format" v-model="bitis"></datepicker>
            </div>
            <vs-input class="inputx" placeholder="Arama" @keyup.enter="stokListesi()"  :ref="barkod" v-model="barkod" />
            <div class="vx-col sm:w-1/4 w-full mb-1">
              <vs-button color="success" @click="Listele()" type="filled"
                >Listele</vs-button
              >
            </div>
          </div>
        </vx-card>

        <vs-table :data="data">
          <template slot="thead">
            <vs-th>Stok Kodu</vs-th>
            <vs-th>Stok Adı</vs-th>
            <vs-th sort-key="satisAdet">Penta Adet</vs-th>
            <vs-th sort-key="satisAdet">Bogazici Adet</vs-th>
            <vs-th>Tarih</vs-th>
            <vs-th>Güncelleme Tarihi</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                {{ data[indextr].stokKartKodu }}
              </vs-td>
              <vs-td>
                {{ data[indextr].aciklama }}
              </vs-td>
              <vs-td>
                {{ data[indextr].PentaAdet }}
              </vs-td>
              <vs-td>
                {{ data[indextr].BogaziciAdet }}
              </vs-td>
              <vs-td>
                {{ new Date(data[indextr].insertDate).toLocaleString()}}
              </vs-td>
              <vs-td>
                {{ new Date(data[indextr].updateDate).toLocaleString()}}
              </vs-td>
            </vs-tr>          
            
          </template>
          <div>
              <vs-tr>
              <vs-td></vs-td>
              <vs-td>Penta Toplam</vs-td>
              <vs-td>{{ toplama() }}</vs-td>
            </vs-tr>
          </div>
        </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import state from "../../store/state";
import Store from "../../store/store";
export default {
  data() {
    return {
      format: "yyyy-MM-dd",
      data: [],
      baslangic: "",
      formattedDate: "",
      formattedDate1: "",
      bitis: "",
      barkod:"",
      toplam: 0,
      program: { id: 0, label: "Pazaryeri" },
      check3: ""
    };
  },
  methods: {
    toplama() {
      var vm = this;
      var sayi = 0;      
      this.data.forEach(element => {
        sayi = sayi + parseInt(element.PentaAdet);
      });
      return sayi;
    },
    Listele() {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;

      var d = new Date(vm.baslangic);
      vm.formattedDate =
        d.getUTCDate() + "." + (d.getUTCMonth() + 1) + "." + d.getUTCFullYear();

      //vm.formattedDate =        d.getUTCFullYear() + "-" + (d.getUTCMonth() + 1) + "-" + d.getUTCDate();
      //console.log(vm.formattedDate)
      var d1 = new Date(vm.bitis);

      vm.formattedDate1 =
        d1.getUTCDate() +
        "." +
        (d1.getUTCMonth() + 1) +
        "." +
        d1.getUTCFullYear();

     // vm.formattedDate1 =
       // d1.getUTCFullYear() +
       // " -" +
      //  (d1.getUTCMonth() + 1) +
       // "-" +
      //  d1.getUTCDate();
      //console.log(vm.formattedDate1)
      const args = {program:'Dia',baslik:'diaStokKartRaporu',ARANAN:vm.barkod,companyID:'',token:Store.state.tokenId,baslangic:vm.formattedDate,bitis:vm.formattedDate1}
      console.log(args)
      soap.createClient(url, function(err, client){
      client.standartSorgular(args, function(err, result){
        if (result.standartSorgularResult=='-1') {
          Store.dispatch('logout')
        }
        console.log(result.standartSorgularResult)
        vm.veriler=JSON.parse(result.standartSorgularResult)        
        vm.data=vm.veriler
       // vm.eslesenStokListesi=vm.veriler
        });
      });
    }
  },
  components: {
    "v-select": vSelect,
    Datepicker
  }
};
</script>

<style>
td { font-size: 10px!important;}
</style>